<template>
	<div id="setting" v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')">
		<div class="container mt-3">

			<ul class="nav nav-tabs" style="padding-top:15px;">
				<li class="nav-item" :class="{'active' : currentView == 'setting'}">
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'setting'"><i class="fas fa-wrench"></i> Setting</a>
				</li>
				<template v-if="selectedBot.theme == 'ecommercebasic'"></template>
				<li class="nav-item" :class="{'active' : currentView == 'billing'}" >
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'billing'"><i class="fas fa-cubes"></i> Billing</a>
				</li>
			</ul>
			<div class="tab-container">
				<br>
				<template v-if="currentView == 'setting'">
					<div>
						<div class="setting-container">
						<h3 class="title">Setting <modal-help  v-if="!$store.state.theme.hide_zwiz" link="https://blog.zwiz.ai/othersettings-zwizai#setting"></modal-help></h3>
							<h4 class="sub-title">
								Activate Bot
							</h4>
							<div class="switch-container">

								<div class="row">
									<div class="col-xs-6" style="margin-top:10px"><label for="activateBot">Activate Bot</label>
										
									</div>
									<div class="col-xs-6 text-right">
										<label class="switch">
											<input type="checkbox" :checked="botStatus" @change="toggleBotStatus()">
											<span class="slider round"></span>
										</label>

									</div>
									<div class="col-xs-12">
										<div class="small" v-if="botStatus && selectedBot && selectedBot.packages">
											<!-- <img :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" alt="" style="border-radius: 50%; width: 30px; height: 30px;border: 1px solid #eee">
											<a v-if="selectedBot.packages.includes('facebook')" :href="'https://m.me/'+selectedBot.pageid" target="_blank"  ><span>Test your messenger bot</span></a> -->
											<a v-if="selectedBot.packages.includes('facebook')" :href="'https://m.me/'+selectedBot.pageid" target="_blank" class="btn btn-fb btn-none-radius "><i class="fab fa-facebook"></i> <span>Test your messenger bot</span></a>	
											<!-- <a href="javascript:void(0);" class="btn btn-line btn-none-radius " > <img src="/static/img/assets/logo/icon-line.png" alt="line" style="margin-right: 5px;" v-if="!selectedBot.packages.includes('line')"> Test Line Bot</a>  -->
										</div>
									</div>
								</div>
							</div>

						</div>
						<div class="setting-container">
							<shop-profile></shop-profile>
						</div>


						<template v-if="selectedBot.theme == 'ecommercebasic'">
							<div class="setting-container">

								<h4 class="sub-title" >Payment <modal-help  v-if="!$store.state.theme.hide_zwiz" link="https://blog.zwiz.ai/othersettings-zwizai/#payment"></modal-help></h4>

								<div class="switch-container" v-if="contents.allowtransfer" style="padding-bottom: 0">

									<div class="row">
										<div class="col-xs-6" style="margin-top:10px"><label for="activateBot">Allow Bank Tranfer</label></div>
										<div class="col-xs-6 text-right">
											<input-boolean-no-label v-model="contents.allowtransfer" @onInputChange="isTransfer = !isTransfer"></input-boolean-no-label>

										</div>
									</div>

									<div class="row">
										<div class="col-xs-12" style="padding:0">

											<transfer-payment  v-if="isTransfer" :init="contents" style="margin-top: 10px;"></transfer-payment>
											
										</div>
									</div>
								</div>

								<div class="switch-container" v-show="contents.allowcreditcard" style="padding-bottom: 0">

									<div class="row" v-if="selectedBot.paypal_merchantid != null">
										<div class="col-xs-6" style="margin-top:10px">
											<label for="activateBot">Allow Credit Card</label>
											<p class="small">Connected with PayPal merchantid: {{selectedBot.paypal_merchantid}} </p>
										</div>
										<div class="col-xs-6 text-right">
											<input-boolean-no-label v-model="contents.allowcreditcard" @onInputChange="isCreditCard = !isCreditCard"></input-boolean-no-label>

										</div>
									</div>

									<div class="row" v-show="!selectedBot.paypal_merchantid">
										<div class="col-xs-12">
											<div v-show="!paypal.haveTrackingId">
												<p>To activate credit card payment, please click "Link PayPal Account"</p>
												<p class="small">Accept credit/debit card through PayPal channel, with only 3.4% fee for domestic transaction, withdraw to your bank account in 3-5 days. </p>
												<div  v-show="!paypal.loading">
														<div class="hidden-xs">
															<div @click="registerPaypalMerchant"  style="display:inline-block;margin-bottom: 15px;overflow: auto;border: 1px solid #b1aeae;background: #002f86;color: white;cursor: pointer;margin-right: 10px;">
																<img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png" alt="" style="display: inline-block;padding: 10px 10px;background: #fff;"> <p style="display:inline-block;padding: 0px 15px;">Link PayPal Account</p>
															</div>
															<a href="javascript:void(0);" style="vertical-align: top;display: inline-block;margin-top: 14px;" @click="showHelpRegisterPaypal = true">How to link PayPal Account?</a>
														</div>
														<div class="hidden-sm hidden-md hidden-lg">
															<div @click="registerPaypalMerchant"  style="display:inline-block;margin-bottom: 5px;overflow: auto;border: 1px solid #b1aeae;background: #002f86;color: white;cursor: pointer; width: 100%">
																<div class="text-center" style="background: white;margin-bottom: 10px;">
																	<img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png" alt="" style="display: inline-block;padding: 10px 10px;background: #fff;">
																</div>
																<p style="padding: 0px 15px;text-align: center">Link PayPal Account</p>
															</div>
															<a href="javascript:void(0);" style="margin-bottom: 14px;display:block;text-align: center" @click="showHelpRegisterPaypal = true">How to link PayPal Account?</a>
														</div>
													

												</div>

												<div v-show="paypal.loading">
													<sync-loader :color="$store.state.theme.brand_color" :size="'10px'" style="display:inline-block;margin-right: 10px;margin-bottom: 15px;"></sync-loader> Loading
												</div>
											</div>
											<div v-show="paypal.haveTrackingId">
												<div style="margin-bottom: 15px;">
													<template v-if="paypal.checkTracking">
														<sync-loader :color="$store.state.theme.brand_color" :size="'10px'" style="display:inline-block;margin-right: 10px"></sync-loader> <span style="display:inline">Pending PayPal Merchant Account Registration</span> 
													</template>
													<template v-else>
														<a href="javascript:void(0);" @click="onRefreshTrackingStatus">
															<span class="glyphicon glyphicon-refresh"></span> Click refresh after you have completed registration
														</a>
													</template>
													| <a href="javascript:void(0);" @click="cancelRegisterPaypalMerchant">Cancel</a>
												</div>
											</div>

										</div>

									</div>

								</div>

								<div class="setting-container" style="padding-bottom: 0;">
									<div class="row">
										<div class="col-xs-12" style="padding:0">

											<shipping-detail :init="contents" style="margin-top: 10px;"></shipping-detail>
											
										</div>
									</div>
								</div>

								<!-- <div class="row">
									<div class="col-xs-12" style="margin-top:10px">
										<div class="alert alert-info" role="alert">Note: To activate credit card payment, please contact <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a></div>
										
									</div>
								</div> -->
							</div>
						</template>

						<template v-if="selectedBot.theme != 'ecommercebasic'">
						<div class="setting-container">
							<h4 class="sub-title">Other</h4>

							<form>
								<div class="row">
									<div class="col-sm-6" v-for="(content,index) in contents" :key="index" style="height:140px;overflow: hidden" :style="{'height': content.datatype == 'image' ? '270px' : '140px'}">
										<component :is="'input-'+ content.datatype" v-model="contents[index]" ></component>
										
									</div>
								</div>
							</form>
						</div>
						</template>

						<div class="setting-container" v-if="selectedBot.theme == 'ecommercebasic'">
							<div class="row">
								<div class="col-xs-3">
									<label for="">Line Notify</label>
								</div>
								<div class="col-xs-9 col-sm-5 text-left">
									
									<textarea name="subscribeLineNotify" ref="subscribeLineNotify" cols="30" style="resize: none;border: 1px solid #eee;" onclick="this.select()"  readOnly="true" v-model="pageid"></textarea>
									<div class="" >
										<a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-clipboard:copy="pageid" v-clipboard:success="onCopy" v-clipboard:error="onError" style="position:relative;margin-right: 10px"><span class="glyphicon glyphicon-file"></span> Copy <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut"><span class="tooltiptext" v-if="showCopy">Copied!</span></transition></a> 
										<a href="javascript:void(0);"  @click="showHelpLineNotify = true">How to use?</a>
									</div>

									<p style="margin-top: 25px">Line notify Subscriber <a href="javascript:void(0);" @click="refreshSubscriber"><span class="glyphicon glyphicon-refresh"></span></a></p>
									
									<div style="overflow: auto;" v-if="lineNotifySubscriber.length > 0">
									
										<div  v-for="(subscriber,index) in lineNotifySubscriber" :key="'subscriber_'+index" style="float:left; border: 1px solid #eee; border-radius: 10px; padding: 10px;margin-bottom: 10px;">
											<div style="float:left;border-radius: 50%;overflow: hidden">
												<img :src="subscriber.profile_pic" style="width: 50px;height: 50px">
											</div>
											<div style="float: left;margin: 15px 15px; width: 120px">
												{{subscriber.first_name + ' ' + subscriber.last_name | truncate(10)}} 
											</div>
											<div style="float: left;margin: 15px; width: 10px">
												<a href="javascript:void(0);" @click="deleteSubscriber(index,subscriber)"><span class="glyphicon glyphicon-remove"></span></a>
											</div>
										</div>
									</div>
									<div v-else>
										
										<p class="small" style="">No Subscriber</p>
										<!-- <div style="float:left;border-radius: 50%;overflow: hidden">
											<img src="/static/img/assets/livechat/profile.png" style="width: 50px;height: 50px">
										</div>
										<div style="float: left;margin: 15px 15px; width: 120px">
											<div style="width: 100%;height: 15px;background: #eee"></div>
										</div> -->
									</div>


									<!-- <div style="margin-bottom: 5px;">
										<a href="javascript:void(0);" class="btn btn-fb btn-none-radius disabled"><img src="/static/img/assets/logo/icon-facebook.png" alt="line" style="margin-right: 5px;"> <span>Sign in with Facebook</span></a>
									</div>
									<a href="javascript:void(0);" class="btn btn-line btn-none-radius disabled"> <img src="/static/img/assets/logo/icon-line.png" alt="line" style="margin-right: 5px;"> Sign in with Line</a> -->
								</div>
							</div>
						</div>

						<div class="setting-container" v-if="$store.state.isFacebook">
							<div class="row">
								<div class="col-sm-3">
									<label for="">Customer Chat Plugin</label>
								</div>
								<div class=" col-sm-9 text-left">
									<p class="small">
										Let people start a conversation on your website and continue in Messenger. It's easy to set up. We'll give you the code to add to your website.
									</p>
									<pre >
										{{customerChatPlugin}}
									</pre>
									<a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-clipboard:copy="customerChatPlugin" v-clipboard:success="onCopyPlugin" v-clipboard:error="onErrorPlugin" style="position:relative;margin-right: 10px"><span class="glyphicon glyphicon-file"></span> Copy <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut"><span class="tooltiptext" v-if="showCopyPlugin">Copied!</span></transition></a> 
								</div>
							</div>
						</div>

						<modal-dialog v-if="showHelpLineNotify" @close="showHelpLineNotify = false">
							<span slot="header">Help</span>

							<div slot="body">
								<h3 class="text-center">How to subscribe line notify</h3>
								<div style="margin-bottom: 25px;text-align: center">
									<p>1. Copy or click a "Copy" button to copy the key</p>
									<img src="/static/img/assets/setting/line_notify/step1.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="margin-bottom: 25px;text-align: center">
									<p>2. Add LINE <a href="https://line.me/R/ti/p/%40zpe5894p">ZWIZ.AI for LINEat</a> (<a href="https://line.me/R/ti/p/%40zpe5894p" target="_blank" rel="noopener noreferrer">https://line.me/R/ti/p/%40zpe5894p</a>) </p>
									<img src="/static/img/assets/setting/line_notify/step2.jpeg" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="margin-bottom: 25px;text-align: center">
									<p>3. Type a key and sent it</p>
									<img src="/static/img/assets/setting/line_notify/step5.jpg" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="text-align: center">
									<p>4. Click refresh button to check subscriber. If you can not subscribe line notify, please contact <a :href="'mailto:'+$store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a></p>
									<img src="/static/img/assets/setting/line_notify/step4.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>									
								
							</div>

							<div slot="footer">
								<a href="javascript:void(0);" class="btn btn-primary" @click="showHelpLineNotify = false">Close</a>
							</div>
						</modal-dialog>

						<modal-dialog v-if="showHelpRegisterPaypal" @close="showHelpRegisterPaypal = false">
							<span slot="header">Help</span>

							<div slot="body">
								<h3 class="text-center">How to Link PayPal Account</h3>
								<div style="margin-bottom: 25px;text-align: center">
									<p>1. Click "Link PayPal Account" button</p>
									<img src="/static/img/assets/setting/register_paypal/step1.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="margin-bottom: 25px;text-align: center">
									<p>2. input email and select Thailand and then click on "Next" button </p>
									<img src="/static/img/assets/setting/register_paypal/step2.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="margin-bottom: 25px;text-align: center">
									<p>3. complete details in form (select Thailand, and THB only)</p>
									<img src="/static/img/assets/setting/register_paypal/step3.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="text-align: center">
									<p>4. Accept to connect with Robolingo Co., Ltd.</p>
									<img src="/static/img/assets/setting/register_paypal/step4.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>
								<hr>
								<div style="text-align: center">
									<p>5. verify e-mail and click "ใช่ นี่คือที่อยู่อีเมลของฉัน" button</p>
									<img src="/static/img/assets/setting/register_paypal/step4_1.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>	
								<hr>
								<div style="text-align: center">
									<p>6. Wait for processing and click "Try to get PayPal merchantid again" button to check connection with PayPal</p>
									<img src="/static/img/assets/setting/register_paypal/step5.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>	
								<hr>
								<div style="text-align: center">
									


									
									<p>7. After you register successfully you will see merchantid on this page. If you can not register, please contact <a :href="'mailto:'+ $store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a> </p>
									<img src="/static/img/assets/setting/register_paypal/step6.png" style="max-width: 300px; width: 100%; margin: auto" alt="">
								</div>									
								
							</div>

							<div slot="footer">
								<a href="javascript:void(0);" class="btn btn-primary" @click="showHelpRegisterPaypal = false">Close</a>
							</div>
						</modal-dialog>

						<div class="setting-container" style="border-bottom: none">

							<div class="row">
								<div class="col-xs-3">
									<label for="">Remove Bot</label>
								</div>
								<div class="col-xs-3">
									<a href="javascript:void(0);" class="btn btn-danger" @click="unsubscribeBot">Remove</a>
								</div>
							</div>
						</div>
					</div>
				</template>

				<template v-else-if="currentView == 'billing'">
					<div class="container-fluid">

						<div style="padding: 0 15px;">
							<div class="row" style="background: #eee">
								<div class="col-xs-12">
									<h3 class="title color-brand" style="margin-top: 25px;margin-bottom: 5px;">Your package</h3>
									<h4 v-if="$store.getters.getPackage == 'premium'">You are using PREMIUM package  </h4>
									<h4 v-else>You are using BASIC package, upgrade to PREMIUM package for only 500 THB/month</h4>
									<br>
								</div>
								<div class="col-xs-12 col-sm-6">
									<p class="small	" style="margin: 0">Subscription Day Remaining</p>
									<h3 style="margin-top: 0; margin-bottom: 25px;" :style="{'color': (expriedDate <= 10 && expriedTime > 0) ? 'red' : ''}">
										<template v-if="$store.getters.getPackage == 'premium'">
											<template v-if="expriedTime > 0">
												<countdown :time="expriedTime * 1000">
													<template slot-scope="props">
														<template v-if="props.days">
															{{ props.days }} <span class="small">Days</span>
														</template>
														<template v-else-if="props.hours > 0">
															{{ props.hours }} <span class="small">Hours</span>
														</template>
														<template v-else-if="props.minutes > 0">
															{{ props.minutes }} <span class="small">minutes</span>
														</template>
														<template v-else>
															{{ props.seconds }} <span class="small">seconds</span>
														</template>
													</template>
												</countdown>
												<!-- {{expriedTime}}  -->
											</template>
										</template>
										<template v-else>-</template>
											
									</h3>
									<p class="small	" style="margin: 0">Expired Date</p>
									<h3 style="margin-top: 0; margin-bottom: 25px;" :style="{'color': (expriedDate <= 10 && expriedTime > 0)? 'red' : ''}"><template v-if="$store.getters.getPackage == 'premium'">{{ selectedBot.expireat | DateFormat('DD/MM/YYYY') }}</template> <template v-else>-</template></h3>
									
								</div>
								<div class="col-xs-12 col-sm-6">
									<p class="small	" style="margin: 0">Package Options</p>
									<h4 v-for="(social,index) in selectedBot.packages" :key="'package_option_'+ index">
										<template v-if="social == 'facebook'">
											<img src="/static/img/assets/logo/icon-facebook-color.png" alt="facebook" style="margin-right: 5px;"> Facebook Chatbot
										</template>
										<template v-else-if="social == 'line'">
											<img src="/static/img/assets/logo/icon-line-color.png" alt="line" style="margin-right: 5px;">Line Chatbot
										</template>
									</h4>
									<br>
								</div>
							</div>

						</div>


						<div style="border: 1px solid #eee;margin-top: 15px;padding-bottom: 25px;">
							<view-package ></view-package>
						</div>
						
					</div>

				</template>
			</div>

		</div>
	</div>
</template>



<script>
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import InputText from './input/InputText'
import InputTextarea from './input/InputTextarea'
import InputNumber from './input/InputNumber'
import InputImage from './input/InputImage'
import InputBoolean from './input/InputBoolean'

import InputBooleanNoLabel from './input-no-label/InputBooleanNoLabel'



//ecommerce theme
import ShopProfile from './ecommerce/ShopProfile'
import TransferPayment from './ecommerce/TransferPayment'
import ShippingDetail from './ecommerce/ShippingDetail'

import FacebookScreen from '@/components/elements/FacebookScreen'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'

import ViewPackage from './ViewPackage'


import moment from 'moment'
import { setInterval, clearInterval } from 'timers';


export default{
	data: function(){

		return {
			contents : {},
			currentView : 'setting',
			botStatus: false,
			isTransfer: false,
			isCreditCard: false,
			isEditTransferPayment: false,
			showCopy: false,
			showCopyPlugin: false,
			lineNotifySubscriber: [],
			showHelpLineNotify: false,
			showHelpRegisterPaypal: false,

			expriedDate: null,
			expriedTime: null,

			paypal: {
				paypal_url: null,
				tracking_id: null,
				loading: true,
				checkTracking: false,
				haveTrackingId: false,

				checkingInterval: null,
				checkingTime: 4,
				checkingTimePerInterval: 5000
			}

		}
	},
	components:{
		InputText,
		InputTextarea,
		InputNumber,
		InputImage,
		InputBoolean,

		InputBooleanNoLabel,


		ShopProfile,
		TransferPayment,
		ShippingDetail,
		FacebookScreen,
		ModalDialog,
		ModalHelp,

		ViewPackage,
		SyncLoader
	},
	computed:{
		...mapGetters({
			// selectedBot: 'selectedBot',
			botlist: 'botlist',
			paypalTrackingId : 'paypalTrackingId'
		}),
		customerChatPlugin: function(){
			return '\n<div id="fb-root"></div>\n' +
			'<script>(function(d, s, id) {\n' +
			'\tvar js, fjs = d.getElementsByTagName(s)[0];\n' +
			'\tif (d.getElementById(id)) return;\n' +
			'\t\tjs = d.createElement(s); js.id = id;\n' +
			'\t\tjs.src = \'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js\';\n' +
			'\t\tfjs.parentNode.insertBefore(js, fjs);\n' +
			'\t}(document, \'script\', \'facebook-jssdk\'));\n'+
			'<\/script>\n\n' +
			'<div class="fb-customerchat"\n' +
			'\tattribution=setup_tool\n' +
			'\tpage_id="'+this.selectedBot.pageid+'">\n' +
			'</div>'
		},
		selectedBot: {
			get () {
				if (this.$store.state.selectedBot == null) {
					return null
				}
				var now = moment()
				var expriedDate = moment(this.$store.state.selectedBot.expireat)
				this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
				this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
				return this.$store.state.selectedBot
			},
			set (bot) {
				let vm = this
				vm.currentBot = bot
				vm.$store.dispatch('selectBot',vm.currentBot)
				location.reload()
			}
		},
		pageid: function(){
			if (!this.$store.state.selectedBot) {
				return null
			}
			return this.$store.state.selectedBot.pageid
		}
	},
	created: function(){
		var vm = this
		vm.paypal.haveTrackingId = vm.paypalTrackingId != null
		vm.paypal.checkTracking = vm.paypal.haveTrackingId && vm.selectedBot.paypal_merchantid == null
		vm.getSetting()
		if (vm.selectedBot.theme == 'ecommercebasic') {
			if (vm.selectedBot.paypal_merchantid == null) {
				if (vm.paypalTrackingId == null) {
						vm.getPaypalUrl()
				} else {
					if (vm.paypal.checkTracking) {
						vm.onRefreshTrackingStatus()
					}
				}
			}
			vm.getLineNotifySubscriber(function(){
	
			})
		}
		vm.botStatus = vm.selectedBot.status
		if (vm.$route.query.tab) {
			switch(vm.$route.query.tab) {
				case 'setting':
				case 'billing':
					vm.currentView = vm.$route.query.tab;
					break;
				default:
					vm.currentView = 'setting';
					break;
			}

		} else {
			vm.currentView = 'setting';
		}
	},
	mounted: function(){
		(function (d, s, id) {
		var js, ref = d.getElementsByTagName(s)[0]; 
		if (!d.getElementById(id)) {
			js = d.createElement(s); js.id = id; js.async = true;
			js.src = "https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js";
			ref.parentNode.insertBefore(js, ref);
		}
		}(document, "script", "paypal-js"));
	},
	methods: {
		getSetting: function(){
			let vm = this
			if (!vm.pageid || vm.pageid == null) {
				return false;
			}
			var data = {
				pageid: vm.$store.state.selectedBot.pageid
			}

			api.getSetting(data,function(error, response){
				if (error) {
					console.error(error)
					return
				}
				
				vm.contents = {}
				$.each(response.data,function(index, val){
					vm.contents[val.contenttype] = val
					if (val.contenttype == 'allowtransfer') {
						vm.isTransfer = val.contentvalue
					}
					if (val.contenttype == 'allowcreditcard') {
						vm.isCreditCard = val.contentvalue
					}
				})

			})
			
			
		},
		unsubscribeBot: function(){
			let vm = this
			if (confirm('Do you want to remove this?')) {
				vm.$store.dispatch('loading')
				let bot = vm.selectedBot
				api.unSubscribe(bot, function(error, response){
					if (error) {
						console.error(error)
						vm.$store.dispatch('loading')
						return
					}

					let newbotlist = vm.botlist
					$.each(newbotlist,function(index, oldbot) {
						if (bot.pageid == oldbot.pageid) {
							newbotlist.splice(index,1)
							return false;
						}
					})

					vm.$store.dispatch('unselectBot')
					vm.$store.dispatch('updateBotlist',newbotlist)
					vm.$store.dispatch('updatePagelist')
					vm.$store.dispatch('loading')
					vm.$router.push("/allbots")
				})
			}
		},
		toggleBotStatus: function(){
			let vm = this
			let bot = Object.assign({},vm.selectedBot)
			bot.status = !bot.status

			let in_status_label = bot.status ? 'stop' : 'start'
				vm.$store.dispatch('loading')
				api.toggleBotStatus(bot,function(error, response){
					if (error) {
						console.error(error)
						vm.$store.dispatch('loading')
						return
					}

					let newbotlist = vm.botlist
					$.each(newbotlist,function(index, oldbot) {
						if (bot.pageid == oldbot.pageid) {
							newbotlist[index].status = bot.status
							return false;
						}
					})
					// console.log(bot)
					vm.botStatus = bot.status
					vm.$store.dispatch('selectBot',bot)
					vm.$store.dispatch('updateBotlist',newbotlist)
					vm.$store.dispatch('loading')
				})
		},
		updateRoute: function() {
			this.$router.push({
				name: 'setting',
				path: '/setting', 
				query: { 
					tab: this.currentView
				}
			})
			this.routeValue = JSON.stringify(this.$route.query)
		},
		onCopy : function(){
			let vm = this
			vm.showCopy = true
			setTimeout(() => {
				vm.showCopy = false
			}, 1000);
		},
		onError : function(){
		},
		onCopyPlugin : function(){
			let vm = this
			vm.showCopyPlugin = true
			setTimeout(() => {
				vm.showCopyPlugin = false
			}, 1000);
		},
		onErrorPlugin : function(){
		},
		getLineNotifySubscriber: function(callback){
			let vm = this
			let data = {
				pageid : vm.pageid
			}

			api.getLineNotifySubscriber(data,function(error,response){
				if (error) {
					  console.error(error);
			      	return
				  }
				  if (response.data) {
					  vm.lineNotifySubscriber = response.data
				  } else {
					  vm.lineNotifySubscriber = []
				  }
				callback()
			})
		},
		refreshSubscriber: function(){
			var vm = this
			vm.$store.dispatch('loading')
			vm.getLineNotifySubscriber(function(){
				vm.$store.dispatch('loading')
			})
		},
		deleteSubscriber: function(index, subscriber){
			if (confirm("Do you want to delete this '"+subscriber.first_name + " " + subscriber.last_name+"' subscriber")) {
				var vm = this
				let data = {
					pageid : vm.pageid,
					userid: subscriber.id
				}
				vm.$store.dispatch('loading')
				api.deleteLineNotifySubscriber(data,function(error,response){
					if (error) {
						console.error(error);
						vm.$store.dispatch('loading')
						return
					}

					if (response.responsecode == 200) {
						vm.lineNotifySubscriber.splice(index,1)
					}
					vm.$store.dispatch('loading')
				})
			}
		},
		getPaypalUrl: function(){
			var vm = this
			vm.paypal.loading = true
			var data = []
			api.getPaypalUrl(data,function(error, response){
				if (error) {
					console.error(error)
					return
				}
				vm.paypal.paypal_url = response.data.links[1].href
				document.getElementById('actionId').href = vm.paypal.paypal_url + '&displayMode=minibrowser'
				vm.paypal.tracking_id = response.tracking_id
				vm.paypal.loading = false

			})
		},
		registerPaypalMerchant: function(){
			var vm = this
			
			document.getElementById('actionId').click();
			
			vm.$store.dispatch('updatePaypalTrackingId',vm.paypal.tracking_id)

			vm.paypal.haveTrackingId = true
			vm.paypal.checkTracking = true
			vm.onRefreshTrackingStatus()
		},
		cancelRegisterPaypalMerchant: function(){
			var vm = this
			if (vm.paypal.checkingInterval != null) {
				clearInterval(vm.paypal.checkingInterval)
			}
			this.getPaypalUrl();
			this.paypal.haveTrackingId = false
			this.paypal.checkTracking = false
			vm.$store.dispatch('updatePaypalTrackingId',null)
		},
		onRefreshTrackingStatus: function(){
			var vm = this
			vm.paypal.checkingTime = 6
			vm.paypal.checkTracking = true

			vm.checkingTrackingStatus(function(status){
				if (status) {
					clearInterval(vm.paypal.checkingInterval)
					vm.paypal.checkTracking = false
				} else {
					vm.paypal.checkingInterval = setInterval(() => {
						vm.checkingTrackingStatus(function(status){
							if (vm.paypal.checkingTime == 0 || status) {
								clearInterval(vm.paypal.checkingInterval)
								vm.paypal.checkTracking = false
							}
							vm.paypal.checkingTime--
						})
					}, vm.paypal.checkingTimePerInterval);
				}
			})

		},
		checkingTrackingStatus: function(callback){
			var vm = this
			var data = {
				tracking_id: vm.paypalTrackingId
			}
			api.getPaypalTrackingStatus(data,function(error, response){
				if (error) {
					console.error(error)
					return
				}

				if (response.status == 'pending') {
					callback(false)
					
				} else if(response.status == 'success' && response.merchant_id != "" && response.merchant_id != null) {
					data = {
						pageid: vm.selectedBot.pageid,
						paypal_merchantid: response.merchant_id
					}
					api.updatePaypalMerchantId(data,function(error, response){
						if (error) {
							console.error(error)
							return
						}
						vm.contents.allowcreditcard.contentvalue = true

						vm.$store.dispatch('updateMerchantId',data.paypal_merchantid)

						callback(true)
					})
				}
			})
		},
	},
	watch: {
		'pageid': function (newVal, oldVal){
			if (newVal != oldVal) {
				this.getSetting()
			}
		},
		currentView: function(){
			this.updateRoute()
		}
	}

}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/Setting.vue